<div class="table-container">
  <mat-table [dataSource]="data" matSort (matSortChange)="sortData($event)" class="mat-table" matSortDisableClear matSortActive="email" matSortDirection="asc">
    <ng-container matColumnDef="status">
      <mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.status ? helperService.getStatusEquivalent(element.status) : '-' }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header="email"> {{ 'module.userProfile.userList.emailMatHeaderCellText' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.email ? element.email : '-' }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="invitationDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header="invitationDate">
        {{ 'module.userProfile.userList.invitedOnMatHeaderTextCell' | translate }}</mat-header-cell
      >
      <mat-cell *matCellDef="let element">
        {{ element.invitationDate ? (element.invitationDate | date : 'dd.MM.y') : '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="registrationDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header="registrationDate">
        {{ 'module.userProfile.userList.registeredOnMtHeaderCellText' | translate }}</mat-header-cell
      >
      <mat-cell *matCellDef="let element">
        {{ element.registrationDate ? (element.registrationDate | date : 'dd.MM.y') : '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="lastLoginDate">
      <mat-header-cell *matHeaderCellDef mat-sort-header="lastLoginDate">
        {{ 'module.userProfile.userList.lastLoginMatHeaderCellText' | translate }}</mat-header-cell
      >
      <mat-cell *matCellDef="let element">
        {{ element.lastLoginDate ? (element.lastLoginDate | date : 'dd.MM.y') : '-' }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="rolesName">
      <mat-header-cell *matHeaderCellDef mat-sort-header="role/name">
        {{ 'module.userProfile.userList.roleNameMatHeaderCellText' | translate }}</mat-header-cell
      >
      <mat-cell *matCellDef="let element" class="rolesContainer">{{ element.rolesName ? element.rolesName : '-' }} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="privilegeAccess">
      <mat-header-cell *matHeaderCellDef>{{ 'module.userProfile.userList.privilegeAccessMatHeaderCellText' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let element">
        <app-svg-icon [src]="element.isPriviledgedAccess ? './assets/icons/green-tick.svg' : './assets/icons/gray-tick.svg'"></app-svg-icon>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="kommune">
      <mat-header-cell *matHeaderCellDef>Kommune</mat-header-cell>
      <mat-cell *matCellDef="let element" class="kommune">
        <div *ngIf="element.kommune">
          <div *ngFor="let kommune of element.kommune | slice : 0 : 3">{{ kommune }}</div>
          <div *ngIf="element.showMore">
            <div *ngFor="let kommune of element.kommune | slice : 3">{{ kommune }}</div>
          </div>
          <span class="showMore" *ngIf="element.kommune.length > 3" (click)="element.showMore = !element.showMore">{{
            element.showMore ? 'weniger anzeigen...' : 'mehr anzeigen...'
          }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="delegate">
      <mat-header-cell *matHeaderCellDef>{{ 'module.userProfile.userList.delegateHeaderCellText' | translate }} </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <div class="delegation" (mouseover)="element.showPopup = true" (mouseout)="element.showPopup = false">
          <div class="popup" *ngIf="element.showPopup && element.delegateEmail">
            <div class="popup-title">Delegiert</div>
            <div class="delegate-name">{{ element.delegateFirstName }} {{ element.delegateLastName }}</div>
            <div class="delegate-email">
              {{ element.delegateEmail }}
            </div>
          </div>
          <app-svg-icon
            class="delegate-icon"
            [class.-inactive]="!element.isDelegationActive"
            src="./assets/icons/user-friends.svg"
            (click)="delegate(element)"
          ></app-svg-icon>
          <mat-slide-toggle
            [(ngModel)]="element.isDelegationActive"
            class="delegate-toggle"
            [disableRipple]="true"
            [disabled]="delegateDisabled(element)"
            (change)="toggleDelegate($event.checked, element)"
          >
          </mat-slide-toggle>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="edit">
      <mat-header-cell class="center" *matHeaderCellDef>{{ 'module.userProfile.userList.editMatHeaderCellText' | translate }}</mat-header-cell>
      <mat-cell class="center" *matCellDef="let element">
        <app-svg-icon class="edit-user" src="./assets/icons/editUser.svg" [class.-disabled]="!element.canManage" (click)="editUser(element)"></app-svg-icon>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="delete">
      <mat-header-cell class="center" *matHeaderCellDef> {{ 'module.userProfile.userList.deleteHeaderCellText' | translate }}</mat-header-cell>
      <mat-cell class="center" *matCellDef="let element">
        <span class="fa fa-trash fa-2x delete" [class.-disabled]="!element.canManage" (click)="removeUser(element)"></span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
    <mat-row [ngClass]="helperService.getStatusClass(row.status)" *matRowDef="let row; columns: columnsToDisplay"> </mat-row>
  </mat-table>
</div>
